import { FC, lazy, Suspense } from "react";

import type { Change } from "diff";
import type { Language } from "src/components/editor";

interface Props {
  diffs: Change[];
  /** @default json */
  language?: Language;
  /** @default "border" */
  variant?: "border" | "plain";
}

const DiffInner = lazy(() =>
  import("./diff-inner").then((m) => ({ default: m.Diff })),
);

export const Diff: FC<Readonly<Props>> = (props) => {
  return (
    <Suspense fallback={null}>
      <DiffInner {...props} />
    </Suspense>
  );
};
